import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import AddExperienceModal from "./AddExperienceModal";

function ProfileTabData({ userData }) {
  const [modalOpen, setModalOpen] = useState();
  console.log("userData", userData)

  return (
    <>
      <div>
        <div className="card card_bodyPadding mb-4">
          <div className="card-body">
            <h6 className="fs-6 fw-bold">About</h6>
            <p>
              {userData?.about || ""}
            </p>

            <h6 className="fs-6 fw-bold mt-3">Social Media</h6>

            <div className="sociel_icons iconSmall mt-3 pb-3  border-2">  
              <ul className="list-unstyled" style={{ display: 'block' }}>
                {/* {userData?.website_url && <li className="mb-3">
                  <div>
                    <a
                      href={userData?.website_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex align-items-center iconSize"
                    >
                      <i className="fa-solid fa-globe"></i>
                      <span className="ms-2 fw-bold text-dark">Website</span>
                    </a>
                    <p className="ms-5 mt-1 mb-0 text-break" style={{ wordBreak: 'break-word' }}>
                      {userData?.website_url || ""}
                    </p>
                  </div>
                </li>} */}

                {userData?.insta_url && <li className="mb-3">
                  <div>
                    <a
                      href={userData?.insta_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex align-items-center iconSize"
                    >
                      <i className="fa-brands fa-instagram"></i>
                      <span className="ms-2 fw-bold text-dark">Instagram</span>
                    </a>
                    <p className="ms-5 mt-1 mb-0 text-break" style={{ wordBreak: 'break-word' }}>
                      {userData?.insta_url || ""}
                    </p>
                  </div>
                </li>
                }
                {userData?.facebook_url && <li className="mb-3">
                  <div>
                    <a
                      href={userData?.facebook_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex align-items-center iconSize"
                    >
                      <i className="fa-brands fa-facebook-f "></i>
                      <span className="ms-2 fw-bold text-dark">Facebook</span>
                    </a>
                    <p className="ms-5 mt-1 mb-0 text-break" style={{ wordBreak: 'break-word' }}>
                      {userData?.facebook_url || ""}
                    </p>
                  </div>
                </li>
                }
                {userData?.youtube_url && <li className="mb-3">
                  <div>
                    <a
                      href={userData?.youtube_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex align-items-center iconSize"
                    >
                      <i className="fa-brands fa-youtube"></i>
                      <span className="ms-2 fw-bold text-dark">YouTube</span>
                    </a>
                    <p className="ms-5 mt-1 mb-0 text-break" style={{ wordBreak: 'break-word' }}>
                      {userData?.youtube_url || ""}
                    </p>
                  </div>
                </li>
                }
                {userData?.x_url && <li className="mb-3">
                  <div>
                    <a
                      href={userData?.x_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex align-items-center iconSize"
                    >
                      <i className="fa-brands fa-x-twitter"></i>
                      <span className="ms-2 fw-bold text-dark">X.</span>
                    </a>
                    <p className="ms-5 mt-1 mb-0 text-break" style={{ wordBreak: 'break-word' }}>
                      {userData?.x_url || ""}
                    </p>
                  </div>
                </li>
                }
              </ul>
            </div>
            {/* <div className="mt-4 mb-2">
            <button className="parkrevieBtn rounded-5 fw-semi-bold ">
              <span>Report Profile</span>
            </button>
          </div> */}
          </div>
        </div>
        {/* <div className="card mb-4 card_bodyPadding">
          <div className="card-body">
            <Row>
              <Col md={12}>
                <div className="d-flex justify-content-between flex-wrap align-items-center mb-3">
                  <h6 className="fs-6 fw-bold" style={{ paddingBottom: "0" }}>
                    Park Visited 0
                  </h6>
                  <button
                    className="parkrevieBtn photoBtn mt-sm-0 mt-2"
                    onClick={() => setModalOpen(true)}
                  >
                    + Add Experience
                  </button>
                </div>
                <div className="tab-content_tour active">
                  <div className="row">
                    <div className="col-6">No Photo added!</div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div> */}
      </div>
      <AddExperienceModal
        show={modalOpen}
        handleClose={() => setModalOpen(false)}
      />
    </>
  );
}

export default ProfileTabData;
